import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { register, error: authError } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password || !confirmPassword) {
      setFormError('Please fill in all fields');
      return;
    }
    if (password !== confirmPassword) {
      setFormError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setFormError('Password must be at least 6 characters long');
      return;
    }
    setIsSubmitting(true);
    setFormError('');
    try {
      await register(name, email, password);
      navigate('/');
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: 'calc(100vh - 80px)',
      background: 'linear-gradient(103.95deg, rgb(227, 238, 255) -0.02%, rgb(252, 213, 229) 99.98%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '2rem',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18)',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: 420,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 16 }}>
          <img src="/app-logo.png" alt="app logo" style={{ height: '42px', width: '42px', marginRight: '8px' }} />
        </div>
        <div style={{ marginBottom: 2, fontWeight: 500, fontSize: 18, color: '#1e3c72' }}>Create your account</div>
        <div style={{ marginBottom: 16, color: '#4f46e5', fontSize: 14, fontWeight: 500, textAlign: 'center' }}>
          Join Telering Process Pvt. Ltd and empower your workspace with ergonomic furniture and high-performance office essentials.
        </div>
        {(formError || authError) && (
          <div style={{ color: '#e53e3e', background: '#fff0f0', borderRadius: 8, padding: '8px 12px', marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 14 }}>
            {formError || authError}
          </div>
        )}
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Full Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              value={name}
              onChange={e => setName(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                transition: 'border 0.2s',
                background: '#f8fafc',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                transition: 'border 0.2s',
                background: '#f8fafc',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Password</label>
            <input
              type="password"
              placeholder="Create a password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                transition: 'border 0.2s',
                background: '#f8fafc',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                transition: 'border 0.2s',
                background: '#f8fafc',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              width: '100%',
              background: '#4f46e5',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '12px 0',
              fontWeight: 600,
              fontSize: 16,
              boxShadow: '0 2px 8px 0 rgba(31, 38, 135, 0.10)',
              marginTop: 16,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {isSubmitting ? 'Creating Account...' : 'Register'}
          </button>
        </form>
        <div style={{ marginTop: 24, fontSize: 15, color: '#222', textAlign: 'center' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#4f46e5', fontWeight: 500, textDecoration: 'none' }}>
            Login here
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage; 